export default { sha: '3329baa8d08fbac4db3aa8723d4a69388a38e828', buildNumber: 'undefined' }
